import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Colors } from "../constants";

const LoadableImage = styled.div`
    width: ${props => props.width};
    height: ${props => props.height};
    transition: filter 1s ease;
    filter: ${props => (!props.loaded ? "blur(3px)" : "unset")};
    background: linear-gradient(${Colors.blackTint30}, ${Colors.blackTint30}), url(${props => props.src}), border-box, 50% 50%;
    // background-image: url(${props => props.src});
    //background-position: 50% 50%;
    //background-origin: border-box;
    background-size: cover;
    position: ${props => (props.position ? props.position : "relative")};
    top: ${props => (props.top ? props.top : "unset")};
    left: ${props => (props.left ? props.left : "unset")};
    z-index: ${props => (props.zIndex ? props.zIndex : "0")};
`;

const ImageLoader = ({ placeholder, image, ...props }) => {
    const runOnce = true;
    const [loadState, setLoadState] = useState({
        src: placeholder,
        loaded: false
    });

    useEffect(() => {
        const img = new Image();

        img.onload = () => {
            setLoadState({
                src: img.src,
                loaded: true
            });
        };
        img.src = image;
    }, [runOnce]);

    return <LoadableImage {...props} {...loadState} />;
};

export default ImageLoader;
